import { CategoryId } from '~/models/category/types'
import { getStaticUrl } from '~/utils/static'

const BASE_MOCKUP_STATIC_PATH = '/nuxt-static/img/category/mockups/sm'

export const categoriesMockupImagesMappings: {
  [categoryId: number]: string
} = Object.freeze({
  [CategoryId.CARS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/car.png`),
  [CategoryId.BIKES]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/bike.png`),
  [CategoryId.BOATS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/boat.png`),
  [CategoryId.PARTS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/parts.png`),
  [CategoryId.VANS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/van.png`),
  [CategoryId.COMMERCIAL]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/van.png`),
  [CategoryId.TRUCKS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/truck-above.png`
  ),
  [CategoryId.BUSES]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/bus.png`),
  [CategoryId.BUILDERS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/builders.png`
  ),
  [CategoryId.SEMITRUCKS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/semitruck.png`
  ),
  [CategoryId.SEMITRAILERS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/semitrailer.png`
  ),
  [CategoryId.TRACTORS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/tractor.png`),
  [CategoryId.FORKLIFTS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/forklift.png`
  ),
  [CategoryId.TRAILERS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/trailer.png`),
  [CategoryId.TAXIS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/taxi.png`),
  [CategoryId.MOTORHOMES]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/motorhome.png`
  ),
  [CategoryId.CAMPERS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/motorhome.png`
  ),
  [CategoryId.CARAVANS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/caravan.png`),
  [CategoryId.RADIOCONTROLS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/radiocontrolled.png`
  ),
  [CategoryId.HOBBY]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/radiocontrolled.png`
  ),
  [CategoryId.GOKARTS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/cart.png`),
  [CategoryId.WATERSPORTS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/watersports.png`
  ),
  [CategoryId.SNOWSPORTS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/wintersports.png`
  ),
  [CategoryId.BICYCLES]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/bicycle.png`),
  [CategoryId.AIRSPORTS]: getStaticUrl(
    `${BASE_MOCKUP_STATIC_PATH}/airsports.png`
  ),
  [CategoryId.JOBS]: getStaticUrl(`${BASE_MOCKUP_STATIC_PATH}/jobs.png`)
})
